import getSliceName from '@om-fe/core/utils/get-slice-name';
import { DEFAULT_DISPLAYED_NUMBER_OF_MATCHES } from '../../utils/match-list.constants';
import { MatchOfTheDayMatchListPublicProps } from './match-of-the-day-match-list';
import {
    MATCH_OF_THE_DAYMATCH_AGGREGATOR_GROUPS_OVERVIEW_PATH,
    MatchOfTheDayMatchListGroupsOverviewTopic,
    slicePrefix,
} from './match-of-the-day-match-list.constants';
import { DisciplineLiveStatus } from '@om-fe/models';
import * as shallowEqual from 'shallowequal';

export function getMatchOfTheDayMatchListSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getMatchOfTheDayMatchListGroupsOverviewTopic(
    disciplineId: string,
    limit: number,
    marketGroupsOverviewIds?: string,
    locationId?: string,
    eventCategoryId?: string,
    liveStatus?: DisciplineLiveStatus,
    dateRange?: string,
): MatchOfTheDayMatchListGroupsOverviewTopic {

    return {
        path: MATCH_OF_THE_DAYMATCH_AGGREGATOR_GROUPS_OVERVIEW_PATH,
        params: {
            disciplineId,
            limitNumberOfEvents: limit,
            marketGroupsOverviewIds,
            eventCategoryId,
            locationId,
            dateRange,
            liveStatus,
        },
    };
}

interface MatchOfTheDayMatchListTopicProps {
    readonly limitNumberOfEvents: number;
    readonly locationId: string | undefined;
    readonly eventCategoryId: string | undefined;
    readonly liveStatus: DisciplineLiveStatus;
    readonly dateRange: string;
}

const getTopicProps = (props: MatchOfTheDayMatchListPublicProps): MatchOfTheDayMatchListTopicProps => ({
    limitNumberOfEvents: props.limitNumberOfEvents || DEFAULT_DISPLAYED_NUMBER_OF_MATCHES,
    locationId: props.locationId,
    eventCategoryId: props.eventCategoryId,
    liveStatus: props.liveStatus,
    dateRange: props.dateRange,
});

export function areMatchOfTheDayMatchListTopicPropsEqual(
    prevProps: MatchOfTheDayMatchListPublicProps,
    newProps: MatchOfTheDayMatchListPublicProps,
): boolean {
    return shallowEqual(getTopicProps(prevProps), getTopicProps(newProps));
}
